var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.blackRoutePath.some(function (nav, index) { return nav === _vm.$route.path; }))?_c('keep-alive',[_c('router-view')],1):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }